import {useState} from 'react';

/**
 *  useModal custom hook:
 *  Allows toggling the modal's visibilty to be decoupled from the modal itself,
 *  so an outside trigger button or a close button from within the modal can toggle its visibilty
 */

export function useModal() {
  const [isVisible, setIsVisible] = useState(false);

  function toggleVisibility() {
    setIsVisible((prev) => !prev);
  }

  return {
    isVisible,
    toggleVisibility,
  };
}
